import axios from 'axios';
import {req, reqPost,exportExcelPost} from './axiosFun';
import {get} from "echarts/lib/component/toolbox/featureManager";
const BASE_URL="";
/**
 * 手工流水
 */
// 接龙解析
export const solitaireFormat=(params)=> {return reqPost(BASE_URL+"/api/solitaireFormat/relayFormat", params) }
// 保存接龙数据
export const saveSolitaire=(params)=>{return reqPost(BASE_URL+"/api/solitaireFormat/saveSolitaire", params) }
// 手工流水分页列表
export const getManualTransPage=(params)=>{return reqPost(BASE_URL+"/api/solitaireFormat/getManualTransPage", params) }
// 导出excel
export const exportManualTrans=(params)=>{return exportExcelPost(BASE_URL+"/api/solitaireFormat/exportManualTrans", params) }
// 获取未开工资的日期列表
export const getUnpaidSalaryDateList=(params)=>{return reqPost(BASE_URL+"/api/solitaireFormat/getUnpaidSalaryDateList", params) }
// 删除手工记录
export const delManualTrans = (params) => { return axios.delete(BASE_URL+"/api/solitaireFormat/delManualTrans?manualId=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 修改手工记录
export const updateManualTrans=(params)=>{return reqPost(BASE_URL+"/api/solitaireFormat/updateManualTrans", params) }
/**
 * 统计数据
 */
// 查询头部统计数据
export const statisticsHeadQuery=(params)=>{return reqPost(BASE_URL+"/api/statisticsDataController/getHeadStatisticsByDataType", params) }
// 查询收入走势
export const getIncomeTrendData=(params)=>{return reqPost(BASE_URL+"/api/statisticsDataController/getIncomeTrendData", params) }
/**
 * 薪资数据
 */
export const generateUnpaidSalaryWageList=(params)=>{return reqPost(BASE_URL+"/api/wage/generateUnpaidSalaryWageList", params) }
export const savePendSalary=(params)=>{return reqPost(BASE_URL+"/api/wage/savePendSalary", params) }
export const queryWagePage=(params)=>{return reqPost(BASE_URL+"/api/wage/queryWagePage", params) }
export const updateWage=(params)=>{return reqPost(BASE_URL+"/api/wage/updateWage", params) }
export const confirmWage=(params)=>{return reqPost(BASE_URL+"/api/wage/confirm", params) }


/**
 * 支付配置信息
 **/
// 支付配置信息-获取支付配置信息列表
export const MachineConfigList = (params) => { return req("post", BASE_URL+"/api/MachineConfig/list", params) };
// 支付配置信息-保存支付配置信息
export const MachineConfigSave = (params) => { return req("post", BASE_URL+"/api/MachineConfig/save", params) };
// 支付配置信息-删除支付配置信息
export const MachineConfigDelete = (params) => { return axios.delete(BASE_URL+"/api/MachineConfig/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 支付配置
 **/
// 支付配置-获取支付配置列表
export const ConfigList = (params) => { return req("post", BASE_URL+"/api/Config/list", params) };
// 支付配置-保存支付配置
export const ConfigSave = (params) => { return req("post", BASE_URL+"/api/Config/save", params) };
// 支付配置-删除支付配置
export const ConfigDelete = (params) => { return axios.delete(BASE_URL+"/api/Config/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 订单管理-交易订单
 **/
// 交易订单-获取交易订单列表
export const OrderList = (params) => { return req("post", BASE_URL+"/api/Order/list", params) };
// 交易订单-s删除交易订单
export const OrderDelete = (params) => { return axios.delete(BASE_URL+"/api/Order/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 交易订单-交易订单退款
export const OrderRefund = (params) => { return req("post", BASE_URL+"/api/Order/refund", params) };



// WEBPACK FOOTER //
// ./src/api/payMG.js